import { render, staticRenderFns } from "./SubscriptionTable.vue?vue&type=template&id=0fc53449"
import script from "./SubscriptionTable.vue?vue&type=script&lang=js"
export * from "./SubscriptionTable.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionTable.vue?vue&type=style&index=0&id=0fc53449&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports